import { TrainingStatus } from "../../services/formacion/formacion.types";

export const LIVE_WINDOW_MIN = 30;

export const TRAINING_STATUS_LABELS: Record<TrainingStatus, string> = {
  SCHEDULED: "Programada",
  LIVE: "En vivo",
  COMPLETED: "Realizada",
};

export function resolveTrainingStatus(
  row: { starts_at: string; duration_min: number },
  now: Date
): TrainingStatus {
  const startsAt = new Date(row.starts_at).getTime();
  const liveStartsAt = startsAt - LIVE_WINDOW_MIN * 60 * 1000;
  const endsAt = startsAt + row.duration_min * 60 * 1000;
  const nowMs = now.getTime();

  if (nowMs < liveStartsAt) return "SCHEDULED";
  if (nowMs < endsAt) return "LIVE";
  return "COMPLETED";
}
